/*
* author: dch
*/
import { ajax } from '@/utils/request';

const api = {
    // 新增供应商基本信息
    createSupplier(data: any) {
        return ajax({
            method: 'post',
            url: `supplier-mgt/suppliers`,
            data
        });
    },
    // 修改供应商基本信息
    editSupplier(data: any, id: string) {
        return ajax({
            method: 'put',
            url: `supplier-mgt/suppliers/${id}`,
            data
        });
    },
    //获取供应商列表
    getSupplierList(data: any) {
        return ajax({
            method: 'get',
            url: `supplier-mgt/suppliers`,
            data
        });
    },
    //获取品牌列表
    getBrandList(data: any) {
        return ajax({
            method: 'get',
            url: `brand-mgt/select-brand-list`,
            data
        });
    },
    //获取品牌分页
    getBrandsList(data: any) {
        return ajax({
            method: 'get',
            url: `brand-mgt/brands`,
            data
        });
    },
    //新建品牌
    createBrand(data: any) {
        return ajax({
            method: 'post',
            url: `brand-mgt/brands`,
            data
        });
    },
    //修改品牌
    upDateBrand(data: any, id: string) {
        return ajax({
            method: 'put',
            url: `brand-mgt/brands/${id}`,
            data
        });
    },
    //禁用供应商
    disabledSupplier(id: any) {
        return ajax({
            method: 'put',
            url: `supplier-mgt/suppliers/${id}/disabled`
        });
    },
    //禁用品牌
    disabledBrand(id: any) {
        return ajax({
            method: 'put',
            url: `brand-mgt/brands/${id}/disabled`
        });
    },
    //禁用材料
    disabledMaterial(id: any) {
        return ajax({
            method: 'put',
            url: `material-mgt/materials/${id}/disabled`
        });
    },
    //启用供应商
    enabledSupplier(id: any) {
        return ajax({
            method: 'put',
            url: `supplier-mgt/suppliers/${id}/enabled`
        });
    },
    //启用品牌
    enabledBrand(id: any) {
        return ajax({
            method: 'put',
            url: `brand-mgt/brands/${id}/enabled`
        });
    },
    //启用材料
    enabledMaterial(id: any) {
        return ajax({
            method: 'put',
            url: `material-mgt/materials/${id}/enabled`
        });
    },
    //移除供应商
    delSupplier(id: any) {
        return ajax({
            method: 'delete',
            url: `supplier-mgt/suppliers/${id}`
        });
    },
    //移除品牌
    delBrand(id: any) {
        return ajax({
            method: 'delete',
            url: `brand-mgt/brands/${id}`
        });
    },
    //移除移除
    delMaterial(id: any) {
        return ajax({
            method: 'delete',
            url: `material-mgt/materials/${id}`
        });
    },
    //获取供应商信息
    getSupplierDetails(id: any) {
        return ajax({
            method: 'get',
            url: `supplier-mgt/suppliers/${id}`
        });
    },
    //获取品牌信息
    getBrandDetails(id: any) {
        return ajax({
            method: 'get',
            url: `brand-mgt/brands/${id}`
        });
    },
    //获取材料分类树
    getClassifiesList() {
        return ajax({
            method: 'get',
            url: `material-mgt/classifies`
        });
    },
    //修改分类名称
    editClassifiesName(data: any, id: string) {
        return ajax({
            method: 'put',
            url: `material-mgt/classifies/${id}`,
            data
        });
    },
    //新增分类名称
    addClassifiesName(data: any) {
        return ajax({
            method: 'post',
            url: `material-mgt/classifies`,
            data
        });
    },
    //移除分类名称
    delClassifiesName(id: string) {
        return ajax({
            method: 'delete',
            url: `material-mgt/classifies/${id}`
        });
    },
    //获取材料列表
    getClassDataList(data: any) {
        return ajax({
            method: 'get',
            url: `material-mgt/materials`,
            data
        });
    },
    //新增材料信息
    createMaterial(data: any) {
        return ajax({
            method: 'post',
            url: `material-mgt/materials`,
            data
        });
    },
    //获取项目列表
    getProjectsList() {
        return ajax({
            method: 'get',
            url: `project-mgt/select-project-list`
        });
    },
    //获取总计划列表
    getPlanTotalList(data: any) {
        return ajax({
            method: 'get',
            url: `material-total-plan-mgt/plan-page`,
            data
        });
    },
    //获取分批计划列表
    getPlanSubList(data: any) {
        return ajax({
            method: 'get',
            url: `material-sub-plan-mgt/plan-page`,
            data
        });
    },
    //获取材料采购列表
    getMaterialCgList(data: any) {
        return ajax({
            method: 'get',
            url: `purchase-mgt/purchase-page`,
            data
        });
    },
    //获取材料台账列表
    getMaterialStockList(data: any) {
        return ajax({
            method: 'get',
            url: `material-stock-mgt/stock`,
            data
        });
    },
    //获取材料入库列表
    getMaterialInList(data: any) {
        return ajax({
            method: 'get',
            url: `material-in-mgt/material`,
            data
        });
    },
    //获取材料出库列表
    getMaterialOutList(data: any) {
        return ajax({
            method: 'get',
            url: `material-out-mgt/material`,
            data
        });
    },
    //获取材料信息
    getMaterDetails(id: string) {
        return ajax({
            method: 'get',
            url: `material-mgt/materials/${id}`
        });
    },
    //修改材料信息
    upDateMaterial(data: any, id: string) {
        return ajax({
            method: 'put',
            url: `material-mgt/materials/${id}`,
            data
        });
    },
    //生成领料单
    submitOrder(id: string) {
        return ajax({
            method: 'put',
            url: `material-in-mgt/create-out-use-order/${id}`
        });
    },
    //获取双包合同
    contractsDoubleList(data: any) {
        return ajax({
            method: 'get',
            url: `contract-apply/contracts`,
            data
        });
    },
    //获取项目班组
    getProjectClassList() {
        return ajax({
            method: 'get',
            url: `labour-class-member/query-project-class-list`
        });
    },
    //获取采购入库材料列表
    getMaterialListPurchase(data: any) {
        return ajax({
            method: 'get',
            url: `material-in-mgt/purchase-material/${data.projectId}`,
            data
        });
    },
    //获取调拨入库材料列表
    getMaterialListAllocate(data: any) {
        return ajax({
            method: 'get',
            url: `material-in-mgt/allocate-material/${data.sourceProjectId}`,
            data
        });
    },

    // 采购入库材料查询
    getMaterialInPurchaseList(data: any) {
        return ajax({
            method: 'get',
            url: `material-in-mgt/purchase-material`,
            data
        });
    },

    // 调拨入库材料查询
    getMaterialInallocateList(data: any) {
        return ajax({
            method: 'get',
            url: `material-in-mgt/allocate-material`,
            data
        });
    },

    //新增入库登记
    createIntoMaterial(data: any) {
        return ajax({
            method: 'post',
            url: `material-in-mgt/materials`,
            data
        });
    },
    //获取入库详情
    getIntoMaterialDetails(id: any) {
        return ajax({
            method: 'get',
            url: `material-in-mgt/materials/${id}`
        });
    },
    //新增出库登记
    createOuttoMaterial(data: any) {
        return ajax({
            method: 'post',
            url: `material-out-mgt/materials`,
            data
        });
    },
    //查看出库详情
    getOutMaterialDetails(id: any) {
        return ajax({
            method: 'get',
            url: `material-out-mgt/materials/${id}`
        });
    },
    //材料出库列表
    getMaterialDataList(data: any) {
        return ajax({
            method: 'get',
            url: `material-out-mgt/material-select-list`,
            data
        });
    },
    //导出
    exportSuppliers(data: any) {
        return ajax({
            method: 'get',
            url: `supplier-mgt/suppliers/export`,
            data: data,
            headers: {},
            type: "blob"
        });
    },
    //导出
    exportPayMentList(data: any) {
        return ajax({
            method: 'get',
            url: `payment-mgt/export`,
            data: data,
            headers: {},
            type: "blob"
        });
    },
    //导出材料
    exportMaterial(data: any) {
        return ajax({
            method: 'get',
            url: `material-mgt/materials/export`,
            data: data,
            headers: {},
            type: "blob"
        });
    },
    //导出材料台账
    exportMaterialStock(data: any) {
        return ajax({
            method: 'get',
            url: `material-stock-mgt/export`,
            data: data,
            headers: {},
            type: "blob"
        });
    },
    //导出入库单
    exportMaterialIn(id: any) {
        return ajax({
            method: 'get',
            url: `material-in-mgt/export/${id}`,
            headers: {},
            type: "blob"
        });
    },
    //导出出库单
    exportMaterialOut(id: any) {
        return ajax({
            method: 'get',
            url: `material-out-mgt/export/${id}`,
            headers: {},
            type: "blob"
        });
    },
    //导入供应商
    importSuppliers(data: any) {
        return ajax({
            method: 'post',
            url: `supplier-mgt/suppliers/import`,
            data,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    },
    //导入材料模板
    importMaterialsTemplate(data: any) {
        return ajax({
            method: 'post',
            url: `material-mgt/materials/import`,
            data,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    },
    //导出供应商模板
    exportSuppliersTemplate() {
        return ajax({
            method: 'get',
            url: `supplier-mgt/suppliers/template`,
            headers: {},
            type: "blob"
        });
    },
    //导出材料模板
    exportMaterialsTemplate() {
        return ajax({
            method: 'get',
            url: `material-mgt/materials/template`,
            headers: {},
            type: "blob"
        });
    },
    //导出合同
    exportcontractList(data: any) {
        return ajax({
            method: 'get',
            url: `contract-apply/export-contract-list`,
            data,
            headers: {},
            type: "blob"
        });
    },
    //获取项目下的材料供应商
    getProjectSupplierList(data: any) {
        return ajax({
            method: 'get',
            url: `supplier-mgt/project-suppliers-select`,
            data
        });
    },
    //确认资料已齐全
    confirmSetDataComplete(id: any) {
        return ajax({
            method: 'put',
            url: `payment-mgt/payment/confirm-data/${id}`,
        });
    },

    // 周转材料台账分页查询
    getTurnoverPage(data: any) {
        return ajax({
            method: 'GET',
            url: `material-stock-mgt/turnover/stock`,
            data
        });
    },

    // 请假导出
    exportMaterialStock2(data: any) {
        return ajax({
            method: 'get',
            url: `material-stock-mgt/export`,
            data: data,
            type: "blob"
        })
    },

    // 材料报表-材料入库单报表-查询
    materialReportInStorage(data: any){
        return ajax({
            method: 'GET',
            url: `material-report-mgt/in-report`,
            data
        });
    },
    // 材料报表-材料入库单报表-统计
    materialReportInStorageCount(data: any){
        return ajax({
            method: 'GET',
            url: `material-report-mgt/in-report/sum`,
            data
        });
    },
    // 材料报表-材料入库单报表-导出
    materialReportInStorageExport(data: any){
        return ajax({
            method: 'get',
            url: `material-report-mgt/in-report/export`,
            data: data,
            type: "blob"
        })
    },

    // 材料报表-项目材料分析表-查询
    materialReportMaterial(data: any){
        return ajax({
            method: 'GET',
            url: `material-report-mgt/project-material-analyse`,
            data
        });
    },
    // 材料报表-项目材料分析表-统计
    materialReportMaterialCount(data: any){
        return ajax({
            method: 'GET',
            url: `material-report-mgt/project-material-analyse/sum`,
            data
        });
    },
    // 材料报表-项目材料分析表-导出
    materialReportMaterialExport(data: any){
        return ajax({
            method: 'get',
            url: `material-report-mgt/project-material-analyse/export`,
            data: data,
            type: "blob"
        })
    },

    // 材料报表-供应商供应及支付汇总表-查询
    materialReportSupplier(data: any){
        return ajax({
            method: 'GET',
            url: `material-report-mgt/supplier-supply-and-pay`,
            data
        });
    },
    // 材料报表-供应商供应及支付汇总表-统计
    materialReportSupplierCount(data: any){
        return ajax({
            method: 'GET',
            url: `material-report-mgt/supplier-supply-and-pay/sum`,
            data
        });
    },
    // 材料报表-供应商供应及支付汇总表-导出
    materialReportSupplierExport(data: any){
        return ajax({
            method: 'get',
            url: `material-report-mgt/supplier-supply-and-pay/export`,
            data: data,
            type: "blob"
        })
    },

    // 材料报表-项目材料付款汇总表-查询
    materialReportSupplierPay(data: any){
        return ajax({
            method: 'GET',
            url: `material-report-mgt/project-supplier-pay`,
            data
        });
    },
    // 材料报表-项目材料付款汇总表-统计
    materialReportSupplierPayCount(data: any){
        return ajax({
            method: 'GET',
            url: `material-report-mgt/project-supplier-pay/sum`,
            data
        });
    },
    // 材料报表-项目材料付款汇总表-导出
    materialReportSupplierPayExport(data: any){
        return ajax({
            method: 'get',
            url: `material-report-mgt/project-supplier-pay/export`,
            data: data,
            type: "blob"
        })
    },

    // 材料报表-项目材料使用汇总表-查询
    materialReportSupplierUse(data: any){
        return ajax({
            method: 'GET',
            url: `material-report-mgt/supplier-project-material`,
            data
        });
    },
    // 材料报表-项目材料使用汇总表-统计
    materialReportSupplierUseCount(data: any){
        return ajax({
            method: 'GET',
            url: `material-report-mgt/supplier-project-material/sum`,
            data
        });
    },
    // 材料报表-项目材料使用汇总表-导出
    materialReportSupplierUseExport(data: any){
        return ajax({
            method: 'get',
            url: `material-report-mgt/supplier-project-material/export`,
            data: data,
            type: "blob"
        })
    },

    // 材料报表-班组领用汇总表-查询
    materialReportUse(data: any){
        return ajax({
            method: 'GET',
            url: `material-report-mgt/class-picking`,
            data
        });
    },
    // 材料报表-班组领用汇总表-统计
    materialReportUseCount(data: any){
        return ajax({
            method: 'GET',
            url: `material-report-mgt/class-picking/sum`,
            data
        });
    },
    // 材料报表-班组领用汇总表-导出
    materialReportUseExport(data: any){
        return ajax({
            method: 'get',
            url: `material-report-mgt/class-picking/export`,
            data: data,
            type: "blob"
        })
    },

    // 材料报表-班组领用明细表-查询
    materialReportUseDetail(data: any){
        return ajax({
            method: 'GET',
            url: `material-report-mgt/class-picking-detail`,
            data
        });
    },
    // 材料报表-班组领用明细表-统计
    materialReportUseDetailCount(data: any){
        return ajax({
            method: 'GET',
            url: `material-report-mgt/class-picking-detail/sum`,
            data
        });
    },
    // 材料报表-班组领用明细表-导出
    materialReportUseDetailExport(data: any){
        return ajax({
            method: 'get',
            url: `material-report-mgt/class-picking-detail/export`,
            data: data,
            type: "blob"
        })
    },

};

export default api;